<ng-content></ng-content>
<ng-template>
  <h2 matDialogTitle>수강중인 학생 목록</h2>
  <mat-dialog-content>
    <app-course-member-list [course]="course"></app-course-member-list>
  </mat-dialog-content>
</ng-template>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-members-button/course-members-button.component.html